export class GenericHead {
  partnerId: number;
  enterpriseId: number;
}
